// DROP — patch PDP sale price (components@product.js non filtra compare_at == price)
// 03/07/2026: % arrotondamento · 06/08/2026: nasconde compare-at se prezzi uguali (anche al load)
(() => {
  const fixSalePrices = (form, variant) => {
    if (!variant) return;

    const { compare_at_price: compareAt, price } = variant;
    const info = form.closest('.product-page__info');
    if (!info) return;

    const hasDiscount = compareAt != null && compareAt > price;

    const percentageEl = info.querySelector('[data-percentage]');
    if (percentageEl) {
      if (hasDiscount) {
        percentageEl.innerText = `-${Math.round(((compareAt - price) * 100) / compareAt)}%`;
        percentageEl.style.display = '';
      } else {
        percentageEl.innerText = '';
        percentageEl.style.display = 'none';
      }
    }

    const compareEl = info.querySelector('[data-compare-at-price]');
    if (compareEl) {
      if (hasDiscount) {
        compareEl.style.display = '';
      } else {
        compareEl.innerText = '';
        compareEl.style.display = 'none';
      }
    }
  };

  const getSelectedVariant = (form) => {
    const jsonEl = form.querySelector('[data-product-json]');
    if (!jsonEl) return null;
    try {
      const product = JSON.parse(jsonEl.textContent);
      const idInput = form.querySelector('[name="id"]');
      const id = idInput ? Number(idInput.value) : null;
      return (product.variants || []).find((v) => v.id === id) || product.variants?.[0] || null;
    } catch (_) {
      return null;
    }
  };

  document.querySelectorAll('.product-page__form').forEach((form) => {
    form.addEventListener('afterVariantChange', (e) => fixSalePrices(form, e.variant));
    fixSalePrices(form, getSelectedVariant(form));
  });
})();
